// extracted by mini-css-extract-plugin
module.exports = {"container":"chart_container_2ITfJ","content":"chart_content_213FW","details":"chart_details_3CVt0","title":"chart_title_3XJz2"};